import { Component, HostListener, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IframeMessageTypeEnum, IframeService, mobileNavigation, PushMessageService } from '@lib/core';
import { ReplaySubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { AppState } from '@lib/store';
import { EnvService } from '@lib/env';
import { MobileService, RouterEvent } from '@lib/util';

@Component({
    selector: 'smart-main',
    templateUrl: './main.component.html',
    standalone: false
})
export class MainComponent implements OnInit {
    private readonly store = inject<Store<AppState>>(Store);
    private readonly router = inject(Router);
    private readonly mobileService = inject(MobileService);
    private readonly pushMessageService = inject(PushMessageService);

    public insideIframe: boolean;

    public isLogin: boolean;
    public isDeeplink: boolean;

    public loading = true;

    private readonly resizeSubject: ReplaySubject<boolean> = new ReplaySubject<boolean>();

    constructor() {
        this.router.events.subscribe(async (event: RouterEvent) => {
            // listen to router events
            if (event instanceof NavigationEnd) {
                IframeService.sendMessage(IframeMessageTypeEnum.ROUTE_CHANGE, event.url);
                this.checkRoute(event.url);
            }
        });

        this.resizeSubject
            .pipe(distinctUntilChanged())
            .subscribe((isMobile: boolean) => this.mobileService.setMobile(isMobile));
    }

    @HostListener('window:resize', ['$event'])
    public onResize(): void {
        this.setMobile(window.innerWidth);
    }

    public closeMobileNav($event: MouseEvent): void {
        $event.preventDefault();
        this.store.dispatch(mobileNavigation({ open: false }));
    }

    public async ngOnInit(): Promise<void> {
        this.insideIframe = IframeService.inIframe();
        this.setMobile(window.innerWidth);
        // A notification tapped on a cold start arrives before anyone is signed in, so the listener
        // must exist here; the signed-in shell later activates the navigation.
        void this.pushMessageService.listen();
    }

    private setMobile(windowSize: number): void {
        if (windowSize >= EnvService.mobileThreshold) {
            this.resizeSubject.next(false);
        } else if (windowSize < EnvService.mobileThreshold) {
            this.resizeSubject.next(true);
        }
    }

    private checkRoute(url: string): void {
        this.isLogin = url.includes('login') || url.includes('impersonation');
        this.isDeeplink = url.includes('deep');
    }
}
